import {request} from '../../utility/services/request';
import {Service} from '../base';
import objectToFormData from '../../utility/Utils';

class CustomUserMicrositioService extends Service {

    validateUserIdJalisco({curp}) {
        return request(
            'GET',
            `${this.baseUrl}/${curp}`
        );
    }

    registerUserMicrositio({curp, email}) {
        const body = {
            curp,
            email
        };
        return request('POST', `${this.baseUrl}`, objectToFormData(body));
    }

    updateEmailUserMicrositio({curp, email}) {
        const body = {email};
        return request(
            'PUT',
            `${this.baseUrl}/${curp}/update`,
            objectToFormData(body),
            null,
            true
        );
    }
}

export default CustomUserMicrositioService;
